import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { KvResultContainer } from '@/shared/ui';
import { useState } from 'react';

const errorTypeArr = [
    { value: 'ITEM', label: '문항 오류' },
    { value: 'ANSWER', label: '답안 및 해설 오류' },
    { value: 'PRINT', label: '시험지 출력 기능 오류' },
    { value: 'ETC', label: '기타' },
];

export const ContactPopup = ({
    onSave,
    type,
    articleId,
}: {
    onSave?: (title: string, contents: string, errorType: string) => void;
    type?: 'pod' | 'item';
    articleId?: string;
}) => {
    const { closeModal } = useModalStore();
    const [errorType, setErrorType] = useState<string>('ITEM');
    const [title, setTitle] = useState<string>('');
    const [contents, setContents] = useState<string>('');

    return (
        <div className="pop_wrap pop_size945 pop_qna">
            <div id="popup_qbank" className="popup_type2">
                {/* header */}
                <div id="header">
                    <h1>
                        문항오류 문의하기{' '}
                        <em>
                            비바샘 회원정보의 이메일로 답변이 발송됩니다.
                        </em>
                    </h1>
                </div>
                <div className="pop_head">
                    <button
                        type="button"
                        className="btn-x btn-x-black"
                        onClick={() => closeModal('contact-popup')}
                    >
                        <span className="sr-only">팝업 닫기</span>
                    </button>
                </div>
                <div className="err_report">
                    <table>
                        <caption>문항오류 문의하기</caption>
                        <colgroup>
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '92%' }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={2} className="check">
                                    {errorTypeArr.map((item, idx) => (
                                        <span key={`error-type-${idx}`}>
                                            <input
                                                type="radio"
                                                name="etype"
                                                value={item.value}
                                                id={`etype${idx + 1}`}
                                                checked={errorType === item.value}
                                                onChange={() => setErrorType(item.value)}
                                            />
                                            <label htmlFor={`etype${idx + 1}`}>{item.label}</label>
                                        </span>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <label htmlFor="title">제목</label>
                                </th>
                                <td>
                                    <input
                                        type="text"
                                        name="title"
                                        id="title"
                                        maxLength={100}
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    <label htmlFor="contents">내용</label>
                                </th>
                                <td>
                                    <textarea
                                        name="contents"
                                        cols={1}
                                        id="contents"
                                        value={contents}
                                        style={{ height: '120px' }}
                                        onChange={(e) => setContents(e.target.value)}
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="btns">
                        <span className="txt_help">
                            비바샘 회원정보의 이메일로 답변이 발송됩니다.
                        </span>
                        <button
                            className="btn btn-default btn-save"
                            onClick={() => onSave && onSave(title, contents, errorType)}
                        >
                            문의하기
                        </button>
                    </div>
                    {type === 'item' && (
                        <>
                            <h2>문항 정보</h2>
                            <div className="quizlist">
                                <KvResultContainer
                                    key={articleId}
                                    articleId={articleId ?? ''}
                                    subId={0}
                                    overflowY="none"
                                    mode="scroll"
                                    // style={{ width: '100%' }}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
